"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* -------------------------------------------------------------------------

	PUNITED.common

	サイト内で共通のスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */

// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.common) PUNITED.common = {};
(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.common;
  var scrollOffset = 100;
  ns.mediaQuery = matchMedia('(max-width: 679px)');
  ns.corpHeader = document.querySelector('.site_header');
  ns.headers = document.querySelectorAll('.site_header, .med_site_header');
  ns.body = document.querySelector('body');
  ns.classes = {
    current: '--current',
    open: '--open',
    pcOpen: '--pc_open',
    spOpen: '--sp_open',
    noScroll: '--no_scroll',
    sticky: '--sticky'
  };
  ns.externalSiteLinkModalHandler = null;

  /* -----------------------------------------------------
  	IEの場合にメッセージを表示
  ----------------------------------------------------- */
  var userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('trident') != -1 || userAgent.indexOf('msie') != -1) {
    $("html").addClass("regacy_ie");
  }
  ns.handleResize = function () {
    var prevHeight = ns.body.offsetHeight;
    var observer = new ResizeObserver(_.debounce(function () {
      var currentHeight = ns.body.offsetHeight;
      if (currentHeight === prevHeight) {
        return;
      }
      prevHeight = currentHeight;
      PUNITED.utils.refreshScrollTriggerPosition();
    }, 400));
    observer.observe(ns.body);
  };
  ns.handleHeaderAndScrollToTop = function () {
    var btn = document.querySelector('.scroll_to_top_btn');
    var header;
    var scrollTop;
    handleScroll(function () {
      setTimeout(function () {
        ns.headers.forEach(function (header) {
          header.classList.add('--visible');
        });
      });
    });
    window.addEventListener('scroll', function () {
      handleScroll();
    }, {
      passive: true
    });
    function handleScroll() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var currentHeader = window.scrollY <= (ns.mediaQuery ? 70 : 80);
      var currentScrollTop = window.scrollY <= scrollOffset;
      if (currentHeader !== header) {
        header = currentHeader;
        ns.body.classList.toggle('--pc_header_short', !currentHeader);
      }
      if (currentScrollTop !== scrollTop) {
        scrollTop = currentScrollTop;
        btn === null || btn === void 0 || btn.classList.toggle('--hidden', currentScrollTop);
      }
      if (callback) {
        callback();
      }
    }
    var upper = document.querySelector('.site_footer__upper');
    if (!upper) {
      return;
    }
    var hScrollMedia = matchMedia('(min-width: 680px) and (max-width: 1279px)');
    var stickyTrigger;
    handleStickyScroll(hScrollMedia.matches);
    hScrollMedia.addEventListener('change', function (e) {
      handleStickyScroll(e.matches);
    });
    function handleStickyScroll(matches) {
      var _stickyTrigger;
      (_stickyTrigger = stickyTrigger) === null || _stickyTrigger === void 0 || _stickyTrigger.kill();
      if (matches) {
        btn.classList.remove(ns.classes.sticky);
        return;
      }
      stickyTrigger = ScrollTrigger.create({
        trigger: upper,
        start: "top bottom",
        end: "bottom bottom",
        onEnter: function onEnter() {
          btn.classList.add(ns.classes.sticky);
        },
        onLeaveBack: function onLeaveBack() {
          btn.classList.remove(ns.classes.sticky);
        }
      });
    }
  };
  ns.handleCorpPcHeaderSearch = function () {
    if (!ns.corpHeader) {
      return;
    }
    var container = ns.corpHeader.querySelector('.site_header__search');
    if (!container) {
      return;
    }
    var submitBtn = ns.corpHeader.querySelector('.site_header__search_submit');
    var closeBtn = ns.corpHeader.querySelector('.site_header__search_close');
    submitBtn.addEventListener('click', function (e) {
      if (container.classList.contains(ns.classes.pcOpen)) {
        return;
      }
      e.preventDefault();
      container.classList.toggle(ns.classes.pcOpen);
    });
    closeBtn.addEventListener('click', function (e) {
      container.classList.toggle(ns.classes.pcOpen);
    });
  };
  ns.handleCorpPcHeaderNav = function () {
    if (!ns.corpHeader) {
      return;
    }
    var groups = ns.corpHeader.querySelectorAll('.site_header__nav_group.--has_children');
    groups.forEach(function (group) {
      var toggles = group.querySelectorAll(".site_header__nav_group_title, .site_header__nav_group_body_close");
      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', handleToggleClick);
      });
    });
    function handleToggleClick(e) {
      if (ns.mediaQuery.matches) {
        return;
      }
      e.preventDefault();
      var currentGroup = e.currentTarget.closest('.site_header__nav_group');
      if (!currentGroup.classList.contains(ns.classes.pcOpen)) {
        groups.forEach(function (group) {
          return group.classList.remove(ns.classes.pcOpen);
        });
      }
      currentGroup.classList.toggle(ns.classes.pcOpen);
    }
  };
  ns.handlePcNavHover = function () {
    var header = document.querySelector('.med_site_header');
    if (!header) {
      return;
    }
    var groups = header.querySelectorAll('.--has_children');
    groups.forEach(function (group) {
      group.addEventListener('pointerenter', handlePointerEnter);
      group.addEventListener('pointerleave', handlePointerLeave);
    });
    function handlePointerEnter(e) {
      e.currentTarget.classList.add(ns.classes.pcOpen);
    }
    function handlePointerLeave(e) {
      e.currentTarget.classList.remove(ns.classes.pcOpen);
    }
  };
  ns.handleHeaderSpNavToggle = function () {
    ns.headers.forEach(function (header) {
      var toggle = header.querySelector('[class*="__sp_btn"]');
      toggle.addEventListener('click', function () {
        var open = header.classList.toggle(ns.classes.spOpen);
        ns.body.classList.toggle(ns.classes.noScroll, open);
      });
      ns.mediaQuery.addEventListener("change", function (e) {
        if (!header.classList.contains(ns.classes.spOpen)) {
          return;
        }
        ns.body.classList.toggle(ns.classes.noScroll, e.matches);
      });
    });
  };
  ns.handleSpNav = function () {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'site_footer';
    var preOpenCurrentSp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var groups = document.querySelectorAll(".".concat(prefix, "__nav_group.--has_children"));
    ns.mediaQuery.addEventListener("change", function (e) {
      groups.forEach(function (group) {
        var body = group.querySelector(".".concat(prefix, "__nav_group_body"));
        var bodyAnimations = body.getAnimations();
        bodyAnimations.forEach(function (animation) {
          animation.cancel();
        });
        if (e.matches) {
          var open = group.classList.contains(ns.classes.spOpen);
          toggleGroup(group, open, {
            duration: 0
          });
        } else {
          // fix stupid Chrome's bug that doesn't reset height value even after calling cancel() on animations
          body.animate([{
            height: 'auto'
          }], {
            fill: 'both',
            duration: 1
          });
        }
      });
    });
    groups.forEach(function (group) {
      var head = group.querySelector(".".concat(prefix, "__nav_group_head"));
      if (preOpenCurrentSp && head.classList.contains(ns.classes.current)) {
        group.classList.add(ns.classes.spOpen);
        if (ns.mediaQuery.matches) {
          toggleGroup(group, true, {
            duration: 0
          });
        }
      }
      var toggle = group.querySelector(".".concat(prefix, "__nav_group_title"));
      toggle.addEventListener('click', function (e) {
        if (!ns.mediaQuery.matches) {
          return;
        }
        e.preventDefault();
        var open = group.classList.toggle(ns.classes.spOpen);
        toggleGroup(group, open);
      });
    });
    function toggleGroup(group, open) {
      var customOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var body = group.querySelector(".".concat(prefix, "__nav_group_body"));
      var lists = body.querySelectorAll(".".concat(prefix, "__nav_group_body > *"));
      var listsHeight = Array.from(lists).reduce(function (h, list) {
        return h + list.offsetHeight;
      }, 0);
      var bodyAnimations = body.getAnimations();
      bodyAnimations.forEach(function (animation) {
        animation.finish();
      });
      var options = _objectSpread({
        fill: 'both',
        duration: 300,
        easing: 'ease'
      }, customOptions);
      if (open) {
        body.animate([{
          height: 0
        }, {
          height: "".concat(listsHeight, "px")
        }], options);
      } else {
        body.animate([{
          height: "".concat(listsHeight, "px")
        }, {
          height: 0
        }], options);
      }
    }
  };
  ns.phFaqModal = function () {
    ns.introModal('faqPopupAccepted', '#faq_modal', '#faq_modal_accept_btn');
  };
  ns.introModal = function () {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medPersonnelAccepted';
    var modalSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#intro_modal';
    var yesSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.intro_popup_box__yes_btn';
    var yes = JSON.parse(window.sessionStorage.getItem(key));
    var modalEl = document.querySelector(modalSelector);
    if (!modalEl) {
      return;
    }
    var modal = PUNITED.utils.modal(modalEl, [], {
      open: !yes,
      closeByBackdrop: false
    });
    var yesBtn = document.querySelector(yesSelector);
    yesBtn.addEventListener('click', function (e) {
      e.preventDefault();
      modal.close();
      window.sessionStorage.setItem(key, JSON.stringify(true));
    });
  };
  ns.externalSiteLinkModal = function () {
    var modalEl = document.querySelector('#external_site_modal');
    if (!modalEl) {
      return;
    }
    var modal = PUNITED.utils.modal(modalEl, [], {
      closeByBackdrop: false
    });
    var linkText = document.querySelector('#external_site_modal_link_text');
    var yesBtn = document.querySelector('#external_site_popup_modal_yes_btn');
    var noBtn = document.querySelector('#external_site_popup_modal_no_btn');
    var triggers = Array.from(document.querySelectorAll('a:not(#external_site_popup_modal_yes_btn):not(.no_modal)'));
    triggers.forEach(handleClick);
    yesBtn.addEventListener('click', function () {
      modal.close();
    });
    noBtn.addEventListener('click', function () {
      modal.close();
    });
    function handleClick(trigger) {
      if (!trigger.hostname || trigger.hostname === window.location.hostname) {
        return;
      }
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var url = e.currentTarget.getAttribute('href');
        linkText.replaceChildren(url);
        yesBtn.setAttribute('href', url);
        modal.open();
      });
    }
    return {
      add: function add(selector) {
        var moreTriggers = document.querySelectorAll(selector);
        moreTriggers.forEach(function (trigger) {
          if (triggers.some(function (t) {
            return t.isSameNode(trigger);
          })) {
            return;
          }
          handleClick(trigger);
        });
      }
    };
  };
  ns.popUp = function () {
    var popups = document.querySelectorAll('.pop_up');
    popups.forEach(function (popup) {
      var close = popup.querySelector('.pop_up__close');
      close.addEventListener('click', handleCloseClick);
      var scrollTop;
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
      handleScroll();
      function handleScroll() {
        var currentScrollTop = window.scrollY <= 900;
        if (currentScrollTop !== scrollTop) {
          scrollTop = currentScrollTop;
          if (scrollTop) {
            popup.classList.add('--open');
          } else {
            popup.classList.remove('--open');
            window.removeEventListener('scroll', handleScroll);
          }
        }
      }
    });
    function handleCloseClick(e) {
      e.currentTarget.parentNode.classList.toggle('--open');
    }
  };
  ns.spRecruitFooterLink = function () {
    var footerRecruitLinks = document.querySelector('#footer_recruit_links');
    if (!footerRecruitLinks) return;
    var originalParent = footerRecruitLinks.parentNode; // 元の親要素を保存
    var originalNextSibling = footerRecruitLinks.nextSibling; // 元の位置を保存

    var updatePosition = function updatePosition() {
      if (ns.mediaQuery.matches) {
        var navRows = document.querySelectorAll('.site_footer__nav_row');
        if (navRows.length > 0) {
          navRows[navRows.length - 1].appendChild(footerRecruitLinks);
        }
      } else {
        // PCに戻ったら元の位置に戻す
        if (originalParent) {
          if (originalNextSibling) {
            originalParent.insertBefore(footerRecruitLinks, originalNextSibling);
          } else {
            originalParent.appendChild(footerRecruitLinks);
          }
        }
      }
    };

    // 初回実行
    updatePosition();

    // リサイズイベントリスナー
    ns.mediaQuery.addEventListener('change', updatePosition);
  };
})();
$(function () {
  PUNITED.common.handleHeaderAndScrollToTop();
  PUNITED.common.handleCorpPcHeaderSearch();
  PUNITED.common.handleCorpPcHeaderNav();
  PUNITED.common.handlePcNavHover();
  PUNITED.common.handleHeaderSpNavToggle();
  PUNITED.common.handleSpNav();
  PUNITED.common.handleSpNav('site_header');
  PUNITED.common.handleSpNav('med_site_header', true);
  PUNITED.useful.simpleTab(".inquiry_footer_tab", ".inquiry_footer_tab__btns", ".inquiry_footer_tab__contents");
  PUNITED.common.introModal();
  PUNITED.common.externalSiteLinkModalHandler = PUNITED.common.externalSiteLinkModal();
  PUNITED.common.popUp();
  PUNITED.common.spRecruitFooterLink();
  PUNITED.common.handleResize();
});